import React from 'react'
import PropTypes from 'prop-types'
import WishlistToggle from '../../wishlist-toggle'

/**
 * Leap Add/Remove wishlist product tile overlay button
 *
 * @param {boolean} isDisabled
 * @param {object} product
 * @param {function} onClick
 */
const LeapWishlistOverlayButton = ({isDisabled, product, onClick}) => {
    return (
        <WishlistToggle
            isDisabled={isDisabled}
            product={product}
            variant="cockpitGallery"
            onClick={onClick}
        />
    )
}

LeapWishlistOverlayButton.propTypes = {
    isDisabled: PropTypes.bool,
    product: PropTypes.object,
    onClick: PropTypes.func
}

export default LeapWishlistOverlayButton
